export default __webpack_public_path__ + "static/mulher-costas-84fee05d8f34e7d18c6ccc3e714866e1.webp";